import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from "@angular/core";
import {UploaderOptions, UploadInput, UploadFile, humanizeBytes, UploadOutput} from "ngx-uploader";
import {ConfigService} from "../../../../../services/configService";
import {Cookie} from "ng2-cookies";
import {Order} from "../../../../../objects/orders/order";
import {UploadService} from "../../../../../services/uploadService";
import {BaseResponse} from "../../../../../objects/common/baseResponse";
import {OrderContent} from "../../../../../objects/orders/orderContent";
import {OrderDataType} from "../../../../../objects/orders/orderDataType";
import {OrderStatus} from "../../../../../objects/orders/orderStatus";
import * as ps from "perfect-scrollbar";
import {ToastsManager } from "ng2-toastr";
/**
 * Created by alex.y on 10/2/2017.
 */
@Component({
    selector: 'order-doc-selector-tab',
    templateUrl: 'docSelector.component.html',
    moduleId: module.id.toString()
})
export class DocSelectorComponent implements OnInit {
    @Input()
    public order: Order;

    @Input()
    public tabNumber: number;

    @Output()
    public completeOrderEvent: EventEmitter<boolean> = new EventEmitter();

    public orderStatus = OrderStatus;

    public docs: Array<string> = [];

    @ViewChild('docSelector') docSelectorRef: ElementRef;

    /*file uploader options start*/
    public options: UploaderOptions;
    public files: UploadFile[];
    public humanizeBytes: Function;
    public uploadInput: EventEmitter<UploadInput> = new EventEmitter<UploadInput>();
    public dragOver: boolean;
    public isFileUploading: boolean = false;
    /*file uploader options end*/

    constructor(public configService: ConfigService, public uploadService: UploadService, public toastrService: ToastsManager) {
        this.files = []; // local uploading files array
        this.uploadInput = new EventEmitter<UploadInput>(); // input events, we use this to emit data to ngx-uploader
        this.humanizeBytes = humanizeBytes;

    }

    public ngOnInit(): void {
        this.getDocs();
        ps.initialize(this.docSelectorRef.nativeElement);
    }

    public ngOnChanges(): void {
        this.getDocs();
    }

    private getDocs(): void {
        this.docs = [];
        for (let orderData of this.order.DataList) {
            if (orderData.Data.Type == OrderDataType.File && (orderData.OrderStatus == this.tabNumber))
                this.docs.push(orderData.Data.Data)
        }
    }

    public startUpload(): void {
        if (this.files.length == 0 || !this.files[0].name || this.files[0].size > 4000000)
            return;

        this.files = this.files.filter((file: UploadFile) => file.size <= 4000000 );

        this.isFileUploading = true;

        let cookie = Cookie.get(this.configService.config.ApiTokenCookieName);

        const event: UploadInput = {
            type: 'uploadFile',
            url: `${this.configService.config.ApiUrl}/upload?orderId=${this.order.Id}&orderstatus=${this.order.Status}`,
            method: 'POST',
            fieldName: "file",
            file: this.files[0],
            data: {'name': this.files[0].name},
            headers: {Authorization: `Bearer ` + cookie}
        };

        this.files = [];

        this.uploadInput.emit(event);
    }

    public onUploadOutput(output: UploadOutput): void {
        if (output.type === 'allAddedToQueue') {
            this.startUpload();
        } else if (output.type === 'addedToQueue' && typeof output.file !== 'undefined') { // add file to array when added
            if(output.file.size > 4000000){
                this.toastrService.error('size must be less than 4 mb', null, {preventDuplicates:true});
                this.files = [];
            }
            else
                this.files.push(output.file);
        } else if (output.type === 'uploading' && typeof output.file !== 'undefined') {
            // update current data in files array for uploading file
            const index = this.files.findIndex(file => typeof output.file !== 'undefined' && file.id === output.file.id);
            this.files[index] = output.file;
        } else if (output.type === 'removed') {
            // remove file from array when removed
            this.files = this.files.filter((file: UploadFile) => file !== output.file);
        } else if (output.type === 'dragOver') {
            this.dragOver = true;
        } else if (output.type === 'dragOut') {
            this.dragOver = false;
        } else if (output.type === 'drop') {
            this.dragOver = false;
        }
        else if (output.type == "done")
            this.handleUploaded(output.file.response as (BaseResponse<OrderContent>));
    }

    public handleUploaded(response: BaseResponse<OrderContent>): void {
        this.isFileUploading = false;

        if (!response.Data)
            return;

        if (response.Data.OrderStatus == this.tabNumber)
            this.docs.push(response.Data.Data.Data);

        this.order.DataList.push(response.Data)
    }

}




// WEBPACK FOOTER //
// ./app/components/Managment/orderManagement/orderData/tabs/docSelector.component.ts